var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { connect } from 'react-redux';
import * as actions from '../actions';
import * as selectors from '../selectors';
import { PERSIANA_ID } from '../../herramientas/constantes';
import Persiana from '../components';
var CONFIG_PERSIANA_DEFECTO = {
  color: '#000000'
};

var getConfigPersiana = function getConfigPersiana(state) {
  var botonPersiana = state.barraHerramientas.botones.find(function (_ref) {
    var id = _ref.id;
    return id === PERSIANA_ID;
  });

  if (!botonPersiana) {
    return CONFIG_PERSIANA_DEFECTO;
  }

  return _extends({}, CONFIG_PERSIANA_DEFECTO, botonPersiana);
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _getConfigPersiana = getConfigPersiana(state),
      color = _getConfigPersiana.color;

  return {
    activa: selectors.getActiva(state),
    color: color,
    posicion: selectors.getPosicion(state)
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onPosicion: function onPosicion(posicion) {
      return dispatch(actions.posicion(posicion));
    }
  };
};

var PersianaContainer = connect(mapStateToProps, mapDispatchToProps)(Persiana);
export default PersianaContainer;